interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-archive-line',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-20 px-6 rounded-lg border border-dashed border-background-300 bg-background-50">
      <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-4">
        <i className={`${icon} text-3xl md:text-4xl`} />
      </div>
      <h3 className="font-heading text-lg md:text-xl text-foreground-950">{title}</h3>
      {description ? (
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}